import React, { useState } from 'react';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';
import { Link } from 'react-router-dom';
import MaximumPayout from '../../components/MaximumPayout';
import { Tooltip } from 'reactstrap';

function OffersWidgetItem({ id, title, payout, epc }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [epcTooltipOpen, setEpcTooltipOpen] = useState(false);

  return (
    <div className="offer-widget-item">
      <Link className="offer-widget-item-title" to={`/offers/${id}`}>
        {title}
      </Link>
      <div className="offer-widget-item-info">
        <div className="offer-widget-item-epc">
          <div id="TooltipEPC" className="offer-widget-item-svg">
            <SVG
              src={`${STATIC_PATH}/img/action-icons/epc-icon.svg`}
              height="20"
              width="20"
              cacheRequests
            />
            {epc === 0 ? '—' : ` ${epc} ₽`}
          </div>
          <Tooltip
            className="tooltip-offers-widget"
            isOpen={epcTooltipOpen}
            placement="bottom"
            target="TooltipEPC"
            toggle={() => {
              setEpcTooltipOpen(!epcTooltipOpen);
            }}
          >
            EPC
          </Tooltip>
        </div>

        <div className="offer-widget-item-reward">
          <div id="TooltipPayout" className="offer-widget-item-svg">
            <SVG
              src={`${STATIC_PATH}/img/action-icons/payout-icon.svg`}
              height="20"
              width="20"
              cacheRequests
            />{' '}
            <MaximumPayout pixels={payout} />
          </div>
          <Tooltip
            className="tooltip-offers-widget"
            isOpen={tooltipOpen}
            placement="bottom"
            target="TooltipPayout"
            toggle={() => {
              setTooltipOpen(!tooltipOpen);
            }}
          >
            Выплата
          </Tooltip>
        </div>
        <Link to={`/offers/${id}`}>
          <SVG
            className="offer-widget-item-arrow"
            src={`${STATIC_PATH}/img/action-icons/arrow.svg`}
            height="20"
            width="20"
            cacheRequests
          />
        </Link>
      </div>
    </div>
  );
}

export default OffersWidgetItem;
